import SlideoutJS from 'slideout';
var Slideout = /** @class */ (function () {
    function Slideout() {
        this.selectors = {
            slideout: '[data-slideout]',
            panel: '[data-slideout-panel]',
            open: '[data-slideout-open]',
            close: '[data-slideout-close]'
        };
        this.nodeList = {
            open: document.querySelectorAll(this.selectors.open),
            close: document.querySelectorAll(this.selectors.close),
            slideouts: document.querySelectorAll(this.selectors.slideout)
        };
        this.htmlElement = {
            panel: document.querySelector(this.selectors.panel)
        };
        this.slideouts = {};
    }
    Slideout.prototype.init = function () {
        var _this = this;
        this.nodeList.slideouts.forEach(function (slideout) {
            _this.slideouts[slideout.dataset.key] = new SlideoutJS({
                panel: _this.htmlElement.panel,
                menu: slideout,
                tolerance: 70,
                duration: 300,
                side: slideout.dataset.side ? slideout.dataset.side : 'left'
            });
        });
        this.addEventListeners();
    };
    Slideout.prototype.addEventListeners = function () {
        var _this = this;
        Object.keys(this.slideouts).forEach(function (key) { return _this.slideoutEvents(key); });
        this.nodeList.open.forEach(function (open) { return open.addEventListener('click', _this.handleOpenClick.bind(_this)); });
        this.nodeList.close.forEach(function (close) { return close.addEventListener('click', _this.handleCloseClick.bind(_this)); });
    };
    Slideout.prototype.slideoutEvents = function (key) {
        var slideout = this.slideouts[key];
        var boundClose = this.close.bind(this, key);
        slideout.menu.style.display = 'none';
        slideout.disableTouch();
        slideout.on('beforeopen', function () {
            slideout.panel.classList.add('slideout-panel-open');
            slideout.menu.style.display = 'block';
        });
        slideout.on('open', function () {
            slideout.panel.addEventListener('click', boundClose, true);
        });
        slideout.on('beforeclose', function () {
            slideout.panel.classList.remove('slideout-panel-open');
            document.body.classList.add('slideout-closing');
            slideout.panel.removeEventListener('click', boundClose, true);
        });
        slideout.on('close', function () {
            document.body.classList.remove('slideout-closing');
            slideout.menu.style.display = 'none';
        });
    };
    Slideout.prototype.handleOpenClick = function (event) {
        var target = event.currentTarget;
        var key = target.dataset.key;
        this.open(key);
    };
    Slideout.prototype.handleCloseClick = function (event) {
        var target = event.currentTarget;
        var key = target.dataset.key;
        this.close(key);
    };
    Slideout.prototype.open = function (key) {
        var slideout = this.slideouts[key];
        slideout.open();
    };
    Slideout.prototype.close = function (key) {
        var slideout = this.slideouts[key];
        slideout.close();
    };
    ;
    return Slideout;
}());
export { Slideout };
;
